import { Component } from '@angular/core';

@Component({
  selector: 'app-paso-modal',
  templateUrl: './paso-modal.component.html',
  styleUrl: './paso-modal.component.scss'
})
export class PasoModalComponent {

}
